/**
 * Campo "Usuário do app" do modal de contato — GUPM-202 (D-3). Vinculado, o nome
 * e o e-mail do contato passam a ser os do cadastro do usuário. A lista já vem só
 * com os usuários livres (`usuariosVinculaveis`); um usuário vinculado que foi
 * desativado não está mais na lista e aparece como opção própria, para o select
 * não fingir "Não é usuário do app". Só apresentação.
 */
import type { UsuarioDoApp } from '@/services/datasources';

interface Props {
  valor: string | null;
  usuarios: readonly UsuarioDoApp[];
  /** Nome exibido quando o usuário vinculado não está mais entre os ativos. */
  nomeAtual: string;
  carregando: boolean;
  /** A lista não carregou: avisa e não presume que o vinculado foi desativado. */
  erro: boolean;
  onEscolher: (id: string | null) => void;
}

const ID = 'contato-usuario';

export default function CampoUsuario({ valor, usuarios, nomeAtual, carregando, erro, onEscolher }: Props) {
  const listaCompleta = !carregando && !erro;
  // O vínculo atual sempre aparece; "desativado" só se a lista carregou e ele não está nela.
  const foraDaLista = valor !== null && !usuarios.some((u) => u.id === valor);
  const rotuloAtual = listaCompleta ? `${nomeAtual} — usuário desativado` : nomeAtual;
  return (
    <div>
      <label htmlFor={ID} className="block text-[11px] font-bold text-jf-muted">Usuário do app</label>
      <select
        id={ID}
        value={valor ?? ''}
        onChange={(e) => onEscolher(e.target.value || null)}
        autoFocus
        aria-describedby={`${ID}-dica`}
        className="mt-0.5 w-full rounded-md border border-jf-border bg-jf-bg px-2 py-1.5 text-xs text-white focus:border-jf-yellow focus:outline-none"
      >
        <option value="">Não é usuário do app</option>
        {foraDaLista && <option value={valor}>{rotuloAtual}</option>}
        {usuarios.map((u) => (
          <option key={u.id} value={u.id}>
            {u.email ? `${u.name} — ${u.email}` : u.name}
          </option>
        ))}
      </select>
      {erro ? (
        <p id={`${ID}-dica`} role="alert" className="mt-0.5 text-[11px] text-red-400">
          Não foi possível carregar os usuários do app. O vínculo atual foi mantido; feche e abra de novo para escolher outro.
        </p>
      ) : (
        <p id={`${ID}-dica`} className="mt-0.5 text-[10px] text-jf-dim">
          {carregando
            ? 'Carregando usuários…'
            : 'Vinculado, o nome e o e-mail vêm do cadastro do usuário. Órgãos e fornecedores: "Não é usuário do app".'}
        </p>
      )}
    </div>
  );
}
